// Per-row visibility schedule shared by Playlist and Layout. `alwaysOn = true`
// means the item is always in the rotation; otherwise startAt / endAt are
// ISO-UTC bounds matching the backend wire format. The dialog UI lives in
// `apps/frame/src/components/RowScheduleDialog.tsx`; the type + helpers
// live here so non-component callers can import them without tripping the
// react-refresh "only export components" rule.
export type RowSchedule = {
  alwaysOn: boolean
  startAt?: string  // ISO-8601 UTC
  endAt?:   string
}

export const DEFAULT_ROW_SCHEDULE: RowSchedule = { alwaysOn: true }

// Compare a schedule against `now`. Bounds are ISO strings, parsed by the
// Date constructor (handles the trailing Z / offset).
export function isVisibleAt(schedule: RowSchedule, now: Date): boolean {
  if (schedule.alwaysOn) return true
  const t = now.getTime()
  if (schedule.startAt) {
    const start = new Date(schedule.startAt).getTime()
    if (!Number.isNaN(start) && t < start) return false
  }
  if (schedule.endAt) {
    const end = new Date(schedule.endAt).getTime()
    if (!Number.isNaN(end) && t > end) return false
  }
  return true
}
